import axios from "axios";
const URL = process.env.VUE_APP_API;

export default {
  createAnswer(payload) {
    return axios.post(`${URL}/answers`, { answer: payload }).then((res) => {
      return res.data;
    });
  },
  updateAnswer(answerId, payload) {
    return axios
      .patch(`${URL}/answers/${answerId}`, { answer: payload })
      .then((res) => {
        return res.data;
      });
  },
  deleteAnswer(answerId) {
    return axios.delete(`${URL}/answers/${answerId}`).then((res) => {
      return res.data;
    });
  },
};
